import React from 'react';
import CombinedEditableSection from '../../../../../../components/CombinedEditableSection.comp';
import { tUi } from '../../../../../../../../utils/dq_lc';
import {
  ActivityWrapper,
  ActivityColumnContainer,
  ActivityHeader,
  ActivityPill,
  ActivityTitle,
  ActivityContent,
  DiscussionButton,
} from '../../../../../styles/LearnTab/activity.styles';
import { SlideTitleHeader } from '../common/SlideTitleHeader.comp';
import { renderTextWithId } from '../common/EditableSlideField.comp';

export const DiscussionSlide = ({
  slide,
  highlightWord,
  isEditMode = false,
  slideEdits = {},
  showEnglishContent = false,
  onSaveEdit,
  onResetEdit,
  onCancelEdit,
  uiLocale = 'en-US',
}) => {
  const origin = slide?._pbdq_origin || slide || {};
  const discTitle = slide?.SlideTitle || origin.discussion_title || origin.title || '';
  const discPrompt = origin.discussion_prompt || origin.prompt || origin.discussion_question || slide?.SlideContent || '';

  const textRendererOptions = { slideEdits, showEnglishContent, highlightWord };

  return (
    <ActivityWrapper>
      <ActivityColumnContainer>
        {/* Header */}
        <ActivityHeader>
          <ActivityPill>{tUi('slide.activity.discussionTime', uiLocale)}</ActivityPill>
          {isEditMode ? (
            <CombinedEditableSection
              slide={slide}
              isEditMode={isEditMode}
              slideEdits={slideEdits}
              showEnglishContent={showEnglishContent}
              onSave={onSaveEdit}
              onReset={onResetEdit}
              onCancel={onCancelEdit}
              TitleComponent={ActivityTitle}
              ContentComponent={ActivityContent}
            />
          ) : (
            <>
              <ActivityTitle>
                {discTitle ? (
                  highlightWord ? highlightWord('title', discTitle) : discTitle
                ) : (
                  <SlideTitleHeader
                    slide={slide}
                    slideEdits={slideEdits}
                    showEnglishContent={showEnglishContent}
                    highlightWord={highlightWord}
                    TitleComponent={ActivityTitle}
                  />
                )}
              </ActivityTitle>
              <ActivityContent>
                {renderTextWithId('content_0', discPrompt, ActivityContent, {}, textRendererOptions)}
              </ActivityContent>
            </>
          )}
        </ActivityHeader>

        {/* Discussion Button */}
        <DiscussionButton>
          {tUi('slide.activity.letsTalkAboutIt', uiLocale)}
        </DiscussionButton>
      </ActivityColumnContainer>
    </ActivityWrapper>
  );
};

export default DiscussionSlide;
